import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";
import Home from "./frontpage/home";
import Login from "./authenticate/login";
import Signup from "./authenticate/signup";
import LoginRedirect from "./authenticate/loginredirect";
import Dashboard from "./dashboard/base";
import AccessDenied from "./authenticate/accessDenied";
import AchDebit from "./achDebit";

class RouterHandle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: "",
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    const frontPageUrls = ["/"];
    const authUrls = [
      "/login",
      "/signup",
      "/login-redirect",
      "/contact-sales",
    ];
    const dashboardUrls1 = [
      "/home", // analytics
      "/analytics",
      "/dacas",
      "/accounts",
      "/all-accounts",
      "/all-accounts/reconnect/",
      "/payments",
      "/cash-management",
      "/payables",
      "/receivables",
      "/account",
      "/logout",
      "/team",
      "/holding-entities",
      "/investors",
      "/income-statement",
      "/balance-sheet",
      "/reports",
      "/reports-custom",
      "/transactions",
      "/pending-transactions",
      "/general-ledger",
      "/custom-tag",
      "/transaction-counterparties",
      // can be removed
      "/dashboard2", // TODO: remove
      "/plaid-link",
      "/manage-connections",
      "/view-by-collection",
      "/placement-settings",
      "/faq"
    ];
    const dashboardUrls2 = [
      "/asset/",
      "/collection/",
      "/bank-accounts/",
      "/holding-entities/",
      "/all-accounts/",
      "/general-ledger/rule/",
      "/custom-tag/rule/",
      "/reports/",
      "/reports-custom/",
      "/reports-custom/editing/",
      "/manage-connections/",
      "/view-by-collection/",
      "receivableinvoice",
      "payableinvoice",
      "/payment-requests",
      "/payment-approvals",
      "/send-funds",
      "/manage-recipients",
      "/transaction-counterparties/",
    ];

    return (
      <>
        {frontPageUrls.includes(window.location.pathname) ? (
          <Router>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        ) : dashboardUrls1.includes(window.location.pathname) ||
          dashboardUrls2.includes(window.location.pathname.split("details/")[0]) ? (
          <Router>
            <Dashboard />
          </Router>
        ) : authUrls.includes(window.location.pathname) ||
          authUrls.includes(window.location.pathname.split("home/")[0]) ? (
          <Router>
            <Routes>
              <Route exact path="/login" element={<Login />} />
              <Route exact path="/signup" element={<Signup />} />
              <Route exact path="/contact-sales" element={<AccessDenied />} />
              <Route exact path="/login-redirect" element={<LoginRedirect />} />
            </Routes>
          </Router>
        ) : (
          <Router>
            <Routes>
              <Route exact path="/ach-debit/:id1/:id2/:id3" element={<AchDebit />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        )}
      </>
    );
  }
}

export default RouterHandle;
